import React from 'react'

import { useIntl } from 'react-intl'
import {
  Select,
  Toggle,
  FormElement,
  Flex,
  SpacingVertical,
  SPACING_4,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'
import { useRecoilState } from 'recoil'
import { modalSaveAsTemplateState } from 'Pages/MessageEdit/recoil/state/modals'

const InputLists = () => {
  const intl = useIntl()

  const [
    { lists, saveToLists, selectAll },
    setModalSaveAsTemplateState
  ] = useRecoilState(modalSaveAsTemplateState)

  const handleChangeSaveToLists = selected => {
    setModalSaveAsTemplateState(prev => ({
      ...prev,
      saveToLists: selected
    }))
  }

  const handleToggleSelectAll = () => {
    setModalSaveAsTemplateState(({ selectAll, ...prev }) => ({
      ...prev,
      selectAll: !selectAll
    }))
  }

  return (
    <>
      <FormElement>
        <Flex justifyContent='space-between'>
          <Text variant={TEXT_VARIANT_BOLD}>
            {intl.formatMessage({
              id: 'Load.Bee.ShareTemplatesWithLists'
            })}
            {' *'}
          </Text>
          <label htmlFor='input-select-all-true'>
            <Flex columnGap='8px' alignItems='center'>
              <Toggle
                variant='sm'
                checked={selectAll}
                onChange={handleToggleSelectAll}
                name='select-all'
                value='true'
              />
              <Text htmlElement='span'>
                {intl.formatMessage({ id: 'Load.Bee.SelectAllLists' })}
              </Text>
            </Flex>
          </label>
        </Flex>
        <SpacingVertical variant={SPACING_4} />
        <Select
          multiple
          placeholder={intl.formatMessage({
            id: 'Load.Common.PlaceHolderSelectMultipleList'
          })}
          options={lists}
          value={saveToLists}
          onChange={handleChangeSaveToLists}
          disabled={selectAll}
        />
      </FormElement>
    </>
  )
}

export default InputLists
